import React, { useState } from 'react'
import { IconButton, Popover, Typography } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

// MUI-based stub of the shadcn `info-popover` in `../backoffice/src/components/info-popover`.
// CRA + craco in `backoffice-catp` does not transpile the shadcn/Tailwind
// TSX flavour of that file (no tsconfig, no @/* alias, no Tailwind, no
// Radix peers). craco's `NormalModuleReplacementPlugin` redirects the
// shared import to this stub so transitive consumers (base-dialog →
// inspections-calendar, multi-document-import-dialog, …) keep working
// in the legacy MUI stack without changing the call sites.
export default function InfoPopover({ message }) {
  const [anchorEl, setAnchorEl] = useState(null)

  if (!message) return null

  const open = Boolean(anchorEl)

  return (
    <>
      <IconButton
        size="small"
        aria-label="Info"
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        <InfoOutlinedIcon fontSize="small" />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        <Typography variant="body2" sx={{ p: 1.5, maxWidth: 300 }}>
          {message}
        </Typography>
      </Popover>
    </>
  )
}
